<template>
  <v-container>
    <div class="mapContainer">
      <l-map
        v-if="marker"
        ref="map"
        :zoom="mapZoom"
        :center="marker"
        :options="mapOptions"
        style="height: 100%"
      >
        <l-tile-layer :url="url" :attribution="attribution" />
        <l-marker :lat-lng="marker" :icon="myIcon">
          <l-icon
            icon-url="null"
            icon-shadow-url="null"
            :icon-size="iconSize"
            :icon-anchor="iconAnchor"
          >
            <v-icon size="50" color="primary">mdi-map-marker</v-icon>
          </l-icon>
        </l-marker>
      </l-map>
    </div>
  </v-container>
</template>

<script>
import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LIcon } from "vue2-leaflet";
import { OpenStreetMapProvider } from "leaflet-geosearch";
export default {
  name: "get-current-position",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon
  },
  props: {
    zoom: {
      type: Number,
      default: 13
    }
  },
  data() {
    return {
      myIcon: L.icon({
        iconUrl: "null",
        shadowUrl: "null",

        iconSize: [50, 50], // size of the icon
        shadowSize: [50, 64], // size of the shadow
        iconAnchor: [16, 37], // point of the icon which will correspond to marker's location
        shadowAnchor: [4, 62], // the same for the shadow
        popupAnchor: [-3, -76] // point from which the popup should open relative to the iconAnchor
      }),
      mapZoom: this.zoom,
      marker: null,
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      mapOptions: {
        zoomSnap: 0.5
      },

      iconSize: [50, 50],
      iconAnchor: [16, 37]
    };
  },
  created() {
    let _ = this;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function(geoLocate) {
        _.updateResponse(geoLocate.coords.latitude, geoLocate.coords.longitude);
      });
    } else {
      _._data.marker = latLng(0, 0);
    }
  },
  methods: {
    updateResponse(coordX, coordY) {
      let _ = this;
      _._data.marker = latLng(coordX, coordY);
      let coordinates = { lat: coordX, lng: coordY };
      this.$emit("getPosition", coordinates);
    }
  }
};
</script>
<style lang="scss" scoped>
.mapContainer {
  height: 500px;
  width: 100%;
  .leaflet-container {
    z-index: 0;
  }
}
</style>
